import { LayoutHeader } from "@/Header";
import { ValidateSelect } from "@/Select";
import { ValidateSelectList } from "@/SelectList";
import { createFileRoute } from "@tanstack/react-router";
import { Controller, useForm } from "react-hook-form";
import { useEffect, useState } from "react";
// import ReservationClass from "@/customer/reservation/ReservationClass";
// import ReservationDaycare from "@/customer/reservation/ReservationDaycare";
// import ReservationHotel from "@/customer/reservation/ReservationHotel";
// import ReservationBeauty from "@/customer/reservation/ReservationBeauty";
interface ReservationParams {
  companySeq?: string;
}
export const Route = createFileRoute("/customer/layout/reservation")({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): ReservationParams => {
    return {
      companySeq: search.companySeq as string,
    };
  },
});
interface OwnerOptions {
  value: string;
  label: string;
}

interface InformSendState {
  storeName: OwnerOptions;
  storeType: string;
  content: string;
  weekly: boolean;
  day: string;
  services: string;
  animal: string;
  agree: boolean;
}

function RouteComponent() {
  const {
    control,
    formState: {},
    watch,
    setValue,
  } = useForm<InformSendState>({
    defaultValues: {
      storeName: { value: "", label: "" },
      storeType: "",
      content: "",
      weekly: false,
      day: "",
      services: "",
      animal: "",
      agree: false,
    },
    mode: "onBlur",
  });

  const { companySeq } = Route.useSearch();
  const companySeqNumber = companySeq ? parseInt(companySeq, 10) : 0;
  console.log(companySeqNumber);
  // const { isOpenModal, clickModal, closeModal } = useOpenModal();
  const [checked] = useState(false);
  const ownerOptions = [
    { value: "1", label: "종합" },
    { value: "2", label: "수업" },
    { value: "3", label: "데이" },
    { value: "4", label: "호텔" },
    { value: "5", label: "미용" },
  ];
  const [storeName, setStoreName] = useState<string>("");
  // const [ setStoreType] = useState<string>("");

  // const bindSubmit = (data: InformSendState) => {
  //   console.log(data);
  //   // handleSubmit(data);
  //   clickModal(); // 모달 열기
  //   // 실제 발송 로직은 모달에서 확인 후 실행
  // };

  // const handleModalConfirm = () => {
  //   clickModal();
  //   alert("발송되었습니다!");
  //   // 실제 발송 로직 실행
  // };

  useEffect(() => {
    setValue("weekly", checked);
  }, [checked]);

  useEffect(() => {
    setStoreName(watch("storeName").label);
  }, [watch("storeName")]);

  useEffect(() => {
    // setStoreType(watch("storeType"));
  }, [watch("storeType")]);

  // console.log(watch());

  return (
    <>
      <LayoutHeader title={"예약"} hasBackBtn hasFootPrint={false} />
      {/* 수신자 */}
      <div className="flex flex-col flex-auto">
        <div className="flex-col flex-auto gap-1 px-5 pt-5 bg-[#F5F5F5] grid grid-cols-1">
          <div className="">
            <Controller
              name="storeName"
              control={control}
              rules={{ required: "필수 선택입니다." }}
              render={({ field }) => (
                <ValidateSelectList
                  {...field}
                  placeholder="위탁사업자 이름"
                  options={ownerOptions}
                />
              )}
            />
            {storeName && (
              <div className="mt-4">
                <Controller
                  name="storeType"
                  control={control}
                  rules={{ required: "필수 선택입니다." }}
                  render={({ field }) => (
                    <ValidateSelect
                      {...field}
                      defaultValues={["1"]}
                      label="예약 유형 선택"
                      required={true}
                      max={1}
                      ThemedClassName="text-[13px] bg-white"
                      options={[
                        { label: "수업예약", value: "1" },
                        { label: "데이케어", value: "2" },
                        { label: "호텔 서비스", value: "3" },
                        { label: "미용 서비스", value: "4" },
                      ]}
                    />
                  )}
                />
              </div>
            )}
            {/* {storeType === "1" && (
              <ReservationClass storeName={storeName} storeType={storeType} />
            )}
            {storeType === "2" && (
              <ReservationDaycare storeName={storeName} storeType={storeType} />
            )}
            {storeType === "3" && (
              <ReservationHotel storeName={storeName} storeType={storeType} />
            )}
            {storeType === "4" && (
              <ReservationBeauty storeName={storeName} storeType={storeType} />
            )} */}
          </div>
        </div>
      </div>
      {/* <div className="w-full px-5 pb-6 bg-[#F5F5F5] pt-10 grid grid-cols-1 gap-5">
        <Button
          className="w-full"
          style={{ pointerEvents: "auto" }}
          onClick={() => bindSubmit()}
          disabled={!isValid}
        >
          <div className="py-3 mx-auto w-full text-base font-semibold text-center text-white bg-orange-400 rounded-full">
            예약 하기
          </div>
        </Button>
        <Button
          className="w-full"
          style={{ pointerEvents: "auto" }}
          onClick={() => handleSubmit(bindSubmit)}
          disabled={!isValid}
        >
          <div className="py-3 mx-auto w-full text-base font-semibold text-center text-white bg-orange-400 rounded-full">
            예약 하기
          </div>
        </Button>
      </div> */}
      {/* 모달 */}
      {/* <MessageModal
        isOpen={isOpenModal}
        onRequestClose={closeModal}
        className="p-6 mx-auto w-full max-w-sm bg-white rounded-2xl shadow-lg outline-none"
        overlayClassName="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50"
        title="알림장 발송"
      >
        <div className="flex-1 py-2 font-semibold text-gray-700 bg-gray-200 rounded-full">
          11111111111
        </div>
        <p className="mb-6 text-center">정말 발송하시겠습니까?</p>
        <div className="flex gap-3">
          <button
            className="flex-1 py-2 font-semibold text-gray-700 bg-gray-200 rounded-full border border-gray-300"
            onClick={closeModal}
          >
            취소
          </button>
          <button
            className="flex-1 py-2 font-semibold text-white bg-orange-400 rounded-full"
            onClick={handleModalConfirm}
          >
            확인
          </button>
        </div>
      </MessageModal> */}
    </>
  );
}
